import React from "react";

const ModalBtn = ({ id, label, btnClass, onClick = false, backdrop }) => {
  return (
    <button
      type="button"
      className={btnClass}
      data-toggle="modal"
      data-target={"#" + id}
      onClick={onClick}
      data-backdrop={backdrop ? "true" : "false"}
    >
      {label}
    </button>
  );
};

export default ModalBtn;
